import React from 'react'
import { NavLink } from "react-router"
import { IoIosHelpCircle } from "react-icons/io";
import { useAuthStore } from '../store/useAuthStore'

export default function Sidebar() {

  const { authUser, logout } = useAuthStore()
  return (
    <aside
      id="sidebar-nav"
      className="bg-white w-[260px] min-h-[1000px] border-r border-[#e5e7eb] flex flex-col pt-7 pb-8 px-5 position-fixed"
    >
      <div id="sidebar-logo" className="flex items-center mb-10">
        <i className="fa-solid fa-cube text-primary text-3xl mr-2 text-[#3b82f6]"></i>
        <span className="text-2xl font-bold text-[#1e293b] tracking-tight">
          Lifeline Admin
        </span>
      </div>
      <nav id="sidebar-NavLinks" className="flex-1">
        <ul className="flex flex-col gap-2">
          <li>
            <NavLink
              to="/"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-[#1e293b] font-semibold  cursor-pointer"
            >
              <i className="fa-solid fa-gauge-high text-lg"></i>{" "}
              Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink to="/products"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-[#64748b] hover:bg-[#f1f5f9] cursor-pointer"
            >
              <i className="fa-solid fa-boxes-stacked"></i> Products
            </NavLink>
          </li>
          <li>
            <NavLink to="/categories" className="flex items-center gap-3 px-4 py-3 rounded-lg text-[#64748b] hover:bg-[#f1f5f9] cursor-pointer">
              <i className="fa-solid fa-tag"></i>
              Categories
            </NavLink>
          </li>
          <li>
            <NavLink to="/orders"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-[#64748b] hover:bg-[#f1f5f9] cursor-pointer"
            >
              <i className="fa-solid fa-cart-shopping"></i> Orders
            </NavLink>
          </li>
          <li>
            <NavLink to="/users"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-[#64748b] hover:bg-[#f1f5f9] cursor-pointer"
            >
              <i className="fa-solid fa-users"></i> Users
            </NavLink>
          </li>
          <li>
            <NavLink to="/vendors"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-[#64748b] hover:bg-[#f1f5f9] cursor-pointer"
            >
              <i className="fa-solid fa-building"></i> Vendors
            </NavLink>
          </li>
          {/* <li>
            <NavLink to="/suppliers"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-[#64748b] hover:bg-[#f1f5f9] cursor-pointer"
            >
              <i className="fa-solid fa-truck"></i> Suppliers
            </NavLink>
          </li> */}
          <li>
            <NavLink to="/inquiries"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-[#64748b] hover:bg-[#f1f5f9] cursor-pointer"
            >
             <IoIosHelpCircle /> Inquiry
            </NavLink>
          </li>
          <li>
            <NavLink to="/setting"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-[#64748b] hover:bg-[#f1f5f9] cursor-pointer"
            >
             <i className="fa-solid fa-gear"></i> Settings
            </NavLink>
          </li>

          <li>
            <span className="flex items-center gap-3 px-4 py-3 rounded-lg text-[#64748b] hover:bg-[#f1f5f9] cursor-pointer"
              onClick={() => logout()}
            >
              <i className="fa-solid fa-right-from-bracket"></i>
              Logout
            </span>
          </li>
        </ul>
      </nav>
      <div
        id="sidebar-user"
        className="flex items-center gap-3 mt-10 p-3 bg-[#f1f5f9] rounded-lg"
      >
        <img
          src={authUser?.avatar}
          className="w-10 h-10 rounded-full object-cover"
          alt="icon"
        />
        <div>
          <div className="font-semibold text-[#1e293b]">{authUser?.fullName}</div>
          <div className="text-xs text-[#64748b]">Admin</div>
        </div>
      </div>
    </aside>
  )
}
